/**
 * Hero row wrapper: on index template, wrap the first two .shopify-section
 * (slideshow + campaign-sidebar) in a single .hero-row div for fixed-width layout.
 */
(function () {
  let heroHeightObserver;
  let resizeTicking = false;

  function getDirectSections(main) {
    return Array.from(main.children).filter((child) => child.classList && child.classList.contains('shopify-section'));
  }

  function syncCampaignHeight(wrapper) {
    if (!wrapper) return;
    if (window.innerWidth < 1024) {
      wrapper.style.removeProperty('--hero-row-media-height');
      return;
    }

    const firstSection = wrapper.querySelector('.shopify-section:first-child');
    if (!firstSection) return;

    const slideshow = firstSection.querySelector('.slideshow-wrapper, slideshow-component, .slideshow');
    const target = slideshow || firstSection;
    const measuredHeight = Math.ceil(target.getBoundingClientRect().height);
    if (measuredHeight > 0) {
      wrapper.style.setProperty('--hero-row-media-height', measuredHeight + 'px');
    }
  }

  function bindHeightSync(wrapper) {
    if (!wrapper) return;

    if (heroHeightObserver) {
      heroHeightObserver.disconnect();
      heroHeightObserver = null;
    }

    const firstSection = wrapper.querySelector('.shopify-section:first-child');
    if (!firstSection || typeof ResizeObserver === 'undefined') return;

    const slideshow = firstSection.querySelector('.slideshow-wrapper, slideshow-component, .slideshow');
    const target = slideshow || firstSection;

    heroHeightObserver = new ResizeObserver(() => {
      syncCampaignHeight(wrapper);
    });
    heroHeightObserver.observe(target);
  }

  function scheduleSync(wrapper) {
    if (resizeTicking) return;
    resizeTicking = true;
    window.requestAnimationFrame(() => {
      syncCampaignHeight(wrapper);
      resizeTicking = false;
    });
  }

  function wrapHeroSections() {
    if (!document.body.classList.contains('index-template')) return;

    var main = document.getElementById('MainContent');
    if (!main) return;

    var wrapper = main.querySelector('.hero-row');
    if (!wrapper) {
      var sections = getDirectSections(main);
      if (sections.length < 2) return;

      var first = sections[0];
      var second = sections[1];

      wrapper = document.createElement('div');
      wrapper.className = 'hero-row';

      main.insertBefore(wrapper, first);
      wrapper.appendChild(first);
      wrapper.appendChild(second);
    }

    syncCampaignHeight(wrapper);
    bindHeightSync(wrapper);
  }

  window.addEventListener('resize', function () {
    const wrapper = document.querySelector('#MainContent .hero-row');
    if (wrapper) {
      scheduleSync(wrapper);
    }
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(wrapHeroSections, 0);
  });

  document.addEventListener('shopify:section:reorder', function () {
    setTimeout(wrapHeroSections, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapHeroSections);
  } else {
    wrapHeroSections();
  }
})();
